var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasetArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 33.5,
    x2: 33.5,
    y1: 25.944,
    y2: 37.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b3b3b"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M40 12H22l-4-4H8c-2.2 0-4 1.8-4 4v8h40v-4c0-2.2-1.8-4-4-4Z",
    style: {
      fill: "#ffa000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 12H8c-2.2 0-4 1.8-4 4v20c0 2.2 1.8 4 4 4h32c2.2 0 4-1.8 4-4V16c0-2.2-1.8-4-4-4Z",
    style: {
      fill: "#ffca28"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.045 12.647v1a.5.5 0 0 1-.5.5h-1.5a1 1 0 0 1 0-2h1.5a.5.5 0 0 1 .5.5zm-2 2.5a1 1 0 0 0-1-1h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.5a1 1 0 0 0 1-1zm-1 2a1 1 0 0 0 1 1h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.5a1 1 0 0 0-1 1zm1 2a1 1 0 0 0-1-1h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.5a1 1 0 0 0 1-1zm-1 2a1 1 0 0 0 1 1h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.5a1 1 0 0 0-1 1zm0 4a1 1 0 0 0 1 1h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.5a1 1 0 0 0-1 1zm1-2a1 1 0 0 0-1-1h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.5a1 1 0 0 0 1-1z",
    fill: "#c28200"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#a)"
    },
    d: "M36.128 26.848a.995.995 0 0 0-.989-.848H31.86a.995.995 0 0 0-.988.848C30.603 28.65 30 32.761 30 33.5a3.5 3.5 0 1 0 7 0c0-.739-.603-4.85-.872-6.652zM33.5 35a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 33.5 35z",
    fill: "url(#a)",
    transform: "translate(.045 1.147)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetArchived);
export default __webpack_public_path__ + "static/media/datasetArchived.da722bf0ce472dea3e2db7765a0fc41e.svg";
export { ForwardRef as ReactComponent };